/**
 * Video testimonials: gradient + play overlay on top of video/embed; on first play
 * the overlay is removed, HTML5 <video> gets native controls, embed URL gets autoplay=1.
 */
(function () {
  'use strict';

  function withAutoplay(src) {
    if (!src) return src;
    var s = String(src);
    if (s.indexOf('autoplay=1') >= 0 || /autoplay=true/i.test(s)) return s;
    var abs = s.indexOf('//') === 0 ? 'https:' + s : s;
    try {
      var u = new URL(abs);
      u.searchParams.set('autoplay', '1');
      return u.toString();
    } catch (e) {
      return s + (s.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
    }
  }

  function startPlayback(wrap, media) {
    wrap.classList.add('cosmic-video-t__player-wrap--playing');
    var o = wrap.querySelector('[data-cosmic-video-t-overlay]');
    if (o) o.setAttribute('hidden', 'hidden');
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      media.controls = true;
      var pr = media.play();
      if (pr && typeof pr.then === 'function') pr.catch(function () {});
      return;
    }
    if (media.tagName === 'IFRAME') {
      var orig = media.getAttribute('src');
      if (orig) media.setAttribute('src', withAutoplay(orig));
    }
  }

  function findPlayable(wrap) {
    var v = wrap.querySelector('video');
    if (v) return v;
    return wrap.querySelector('iframe');
  }

  function bind(wrap) {
    if (wrap.getAttribute('data-cosmic-video-t-bound') === '1') return;
    wrap.setAttribute('data-cosmic-video-t-bound', '1');
    var media = findPlayable(wrap);
    var overlay = wrap.querySelector('[data-cosmic-video-t-overlay]');
    if (!media || !overlay) return;

    function onActivate() {
      startPlayback(wrap, media);
    }

    overlay.addEventListener('click', onActivate);
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate();
      }
    });
  }

  function init(context) {
    var root = context && context.querySelectorAll ? context : document;
    if (!root.querySelectorAll) return;
    var nodes = root.querySelectorAll('[data-cosmic-video-t-player]');
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) init(e.target);
  });
})();
